import ModalUtil from 'common/util/ModalUtil';

export default () => Component(function ($context) {
    return $context.select('.js-orderstatus');
}, function ($orderstatus, self) {
    $.extend(self, {
        initEventListeners: function () {
            $orderstatus.on('click', function () {
                if ($.fn.orderstatus === undefined) {
                    $.when(
                        $.getScript('/wa-apps/shop/plugins/orderstatus/js/jquery.orderstatus.min.js'),
                        $.Deferred(function (deferred) {
                            $(deferred.resolve);
                        })).done(function () {
                        self.openModal();
                    });
                } else {
                    self.openModal();
                }
            })
        },
        openModal: function () {
            ModalUtil.openContent($($('#modal-status-template').prop('content').cloneNode(true)));
        }
    });

    self.initEventListeners();
});
